export default __webpack_public_path__ + "static/media/main box4.66c0dcd1.png";